import { Outlet } from "react-router-dom";
import { FixedCostExtrasPanel } from "@/components/organisms";
import { FixedCostExtrasAdd } from "./FixedCostExtrasAdd";
import { FixedCostExtrasEdit } from "./FixedCostExtrasEdit";

export const FixedCostExtras = () => {
  return (
    <>
      <FixedCostExtrasPanel />
      <Outlet />
    </>
  );
};

FixedCostExtras.Edit = FixedCostExtrasEdit;
FixedCostExtras.Add = FixedCostExtrasAdd;
